import React from 'react'
import '@/styles/components/maintenance.css'

interface Props {
  message: string
}

/**
 * Full-screen "down for maintenance" notice.
 *
 * Shown in place of the whole app (no header, footer, routes, or sign-in) when
 * the backend reports the portal is offline. Deliberately self-contained: it
 * must render without a session or any further API calls, since those are
 * closed while maintenance is on.
 */
function MaintenanceScreen({ message }: Props): React.JSX.Element {
  return (
    <div className="maintenance-screen">
      <div className="maintenance-card">
        <div className="maintenance-masthead">
          <img
            src="/mcqueens-logo.png"
            alt="McQueens Dairies"
            className="maintenance-logo"
          />
        </div>
        <div className="maintenance-body">
          <h1 className="maintenance-title">Down for maintenance</h1>
          <p className="maintenance-message">{message}</p>
          <p className="maintenance-help">
            Need to reach us? Call <a href="tel:03305555588">0330 555 5588</a>.
          </p>
        </div>
      </div>
    </div>
  )
}

export default MaintenanceScreen
